import { matchPath } from 'react-router-dom';

export const matchParams = (pathname: string, route: string, exact = true) => {
  const match = matchPath<{ bookId?: string; docId?: string; folderId?: string }>(pathname, { path: route, exact });
  if (match) {
    return { ...match.params };
  }
  return null;
};
